module.exports = __webpack_public_path__ + "media/chat.4d935a0c.mp3";